import { createClient } from '@supabase/supabase-js'
import { variables } from '$lib/variables'

const supabase = createClient(variables.supabaseUrl?.toString()!, variables.supabaseAnonKey?.toString()!)

export default supabase